(function () {
  const SELECTOR = "product-info[id^='MainProduct']";
  const NP_UPLOAD_ACCEPT = "image/jpeg,image/png,image/webp,image/gif,image/heic,image/heif,image/avif,.jpg,.jpeg,.png,.webp,.gif,.heic,.heif,.avif";
  const NP_UPLOAD_MAX_BYTES = 25 * 1024 * 1024;
  const NP_UPLOAD_EXTENSIONS = new Set(["jpg", "jpeg", "png", "webp", "gif", "heic", "heif", "avif"]);
  const NP_UPLOAD_MIMES = new Set(["image/jpeg", "image/png", "image/webp", "image/gif", "image/heic", "image/heif", "image/avif"]);


  function parseJson(node) {
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      return null;
    }
  }

  function getSelectedOptions(variantSelects) {
    return getOptionGroups(variantSelects)
      .map((group) => {
        const checked = group.querySelector('input:checked');
        if (checked) return checked.value;
        const selected = group.querySelector('select');
        return selected ? selected.value : '';
      })
      .filter(Boolean);
  }

  function getOptionGroups(variantSelects) {
    return Array.from(variantSelects.querySelectorAll('fieldset, .product-form__input--dropdown'));
  }

  function getSelectedOptionsByIndex(variantSelects) {
    return getOptionGroups(variantSelects).map((group) => {
      const checked = group.querySelector('input:checked');
      if (checked) return checked.value;
      const selected = group.querySelector('select');
      return selected ? selected.value : '';
    });
  }

  function hasAvailableVariant(variants, options) {
    return variants.some((variant) =>
      variant.available &&
      variant.options &&
      variant.options.every((option, index) => !options[index] || option === options[index])
    );
  }

  function stagedCandidate(selectedOptions, index, value) {
    return selectedOptions.map((option, optionIndex) => {
      if (optionIndex < index) return option;
      if (optionIndex === index) return value;
      return '';
    });
  }

  function setOptionDisabled(control, disabled) {
    control.disabled = disabled;
    control.toggleAttribute('aria-disabled', disabled);
    control.dataset.npUnavailable = disabled ? 'true' : 'false';

    if (control.id) {
      const label = document.querySelector(`label[for="${CSS.escape(control.id)}"]`);
      if (label) {
        label.classList.toggle('np-option-unavailable', disabled);
        label.setAttribute('aria-disabled', disabled ? 'true' : 'false');
      }
    }
  }

  function optionCandidateForControl(variantSelects, control) {
    const groups = getOptionGroups(variantSelects);
    const group = control.closest('fieldset, .product-form__input--dropdown');
    const index = groups.indexOf(group);
    if (index === -1) return null;

    return stagedCandidate(getSelectedOptionsByIndex(variantSelects), index, control.value);
  }

  function optionIndexForControl(variantSelects, control) {
    const groups = getOptionGroups(variantSelects);
    const group = control?.closest?.('fieldset, .product-form__input--dropdown');
    return groups.indexOf(group);
  }

  function isControlAvailable(variantSelects, control) {
    if (!control || !control.value) return true;
    const variants = parseJson(variantSelects.querySelector('[data-np-product-variants]')) || [];
    const candidate = optionCandidateForControl(variantSelects, control);
    if (!variants.length || !candidate) return true;
    return hasAvailableVariant(variants, candidate);
  }

  function rememberAvailableSelection(variantSelects) {
    const productInfo = variantSelects.closest(SELECTOR);
    if (productInfo) productInfo.__npLastAvailableOptions = getSelectedOptionsByIndex(variantSelects);
  }

  function restoreAvailableSelection(variantSelects) {
    const previous = variantSelects.closest(SELECTOR)?.__npLastAvailableOptions;
    if (!previous) return;

    getOptionGroups(variantSelects).forEach((group, index) => {
      const value = previous[index];
      if (!value) return;

      const radio = group.querySelector(`input[type="radio"][value="${CSS.escape(value)}"]`);
      if (radio) radio.checked = true;

      const select = group.querySelector('select');
      if (select) select.value = value;
    });
  }

  function refreshAllVariantAvailability(productInfo) {
    productInfo.querySelectorAll('variant-selects').forEach((variantSelects) => {
      updateOptionAvailability(variantSelects);
      refreshSummaries(variantSelects);
    });
  }

  function selectedControl(group) {
    return group.querySelector('input[type="radio"]:checked') || group.querySelector('select');
  }

  function clearInvalidFollowingSelections(variantSelects, changedIndex) {
    if (changedIndex < 0) return;
    const variants = parseJson(variantSelects.querySelector('[data-np-product-variants]')) || [];
    if (!variants.length) return;

    const groups = getOptionGroups(variantSelects);
    const selectedOptions = getSelectedOptionsByIndex(variantSelects);
    groups.forEach((group, index) => {
      if (index <= changedIndex) return;
      const control = selectedControl(group);
      if (!control || !control.value) return;

      const candidate = stagedCandidate(selectedOptions, index, control.value);
      if (hasAvailableVariant(variants, candidate)) return;

      if (control.matches('input[type="radio"]')) {
        control.checked = false;
      } else {
        control.value = '';
      }
      selectedOptions[index] = '';
    });
  }

  function bindAvailabilityGuards(productInfo) {
    if (productInfo.dataset.npAvailabilityGuards === 'true') return;
    productInfo.dataset.npAvailabilityGuards = 'true';

    ['pointerdown', 'click'].forEach((eventName) => {
      productInfo.addEventListener(eventName, (event) => {
        const variantSelects = event.target.closest?.('variant-selects');
        if (!variantSelects || !productInfo.contains(variantSelects)) return;
        updateOptionAvailability(variantSelects);
        blockUnavailableChoice(event, variantSelects);
      }, true);
    });

    productInfo.addEventListener('change', (event) => {
      const variantSelects = event.target.closest?.('variant-selects');
      if (!variantSelects || !productInfo.contains(variantSelects)) return;
      if (blockUnavailableChoice(event, variantSelects)) return;
      updateOptionAvailability(variantSelects);
    }, true);
  }

  function controlFromVariantEvent(variantSelects, target) {
    const label = target.closest?.('label');
    if (label && variantSelects.contains(label)) {
      if (label.htmlFor) return document.getElementById(label.htmlFor);
      return label.querySelector('input, select');
    }

    const control = target.closest?.('input[type="radio"], select');
    return control && variantSelects.contains(control) ? control : null;
  }

  function blockUnavailableChoice(event, variantSelects) {
    const control = controlFromVariantEvent(variantSelects, event.target);
    if (!control) return false;

    const blocked =
      control.disabled ||
      control.dataset.npUnavailable === 'true' ||
      control.getAttribute('aria-disabled') === 'true' ||
      !isControlAvailable(variantSelects, control);

    if (!blocked) return false;

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation?.();
    restoreAvailableSelection(variantSelects);
    updateOptionAvailability(variantSelects);
    refreshSummaries(variantSelects);
    return true;
  }

  function updateOptionAvailability(variantSelects) {
    const variants = parseJson(variantSelects.querySelector('[data-np-product-variants]')) || [];
    if (!variants.length) return;

    const selectedOptions = getSelectedOptionsByIndex(variantSelects);
    getOptionGroups(variantSelects).forEach((group, index) => {
      group.querySelectorAll('input[type="radio"]').forEach((input) => {
        const candidate = stagedCandidate(selectedOptions, index, input.value);
        setOptionDisabled(input, !hasAvailableVariant(variants, candidate));
      });

      const select = group.querySelector('select');
      if (select) {
        Array.from(select.options).forEach((option) => {
          if (!option.value) return;
          const candidate = stagedCandidate(selectedOptions, index, option.value);
          option.disabled = !hasAvailableVariant(variants, candidate);
        });
      }
    });
  }

  function syncVariant(variantSelects) {
    const variants = parseJson(variantSelects.querySelector('[data-np-product-variants]')) || [];
    const selectedOptions = getSelectedOptions(variantSelects);
    if (!variants.length || !selectedOptions.length) return null;

    const variant = variants.find((item) =>
      item.options && item.options.every((option, index) => option === selectedOptions[index])
    );

    if (!variant) return null;

    const selectedVariantScript = variantSelects.querySelector('[data-selected-variant]');
    if (selectedVariantScript) selectedVariantScript.textContent = JSON.stringify(variant);

    const productInfo = variantSelects.closest(SELECTOR);
    const sectionId = variantSelects.dataset.section || productInfo?.dataset.section;
    if (sectionId) {
      productInfo
        ?.querySelectorAll(`#product-form-${sectionId} input[name="id"], #product-form-installment-${sectionId} input[name="id"]`)
        .forEach((input) => {
          input.value = variant.id;
          input.disabled = !variant.available;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    const submitButton = productInfo?.querySelector('[id^="ProductSubmitButton-"]');
    if (submitButton) {
      submitButton.toggleAttribute('disabled', !variant.available);
      if (variant.available) {
        submitButton.removeAttribute('aria-disabled');
      } else {
        submitButton.setAttribute('aria-disabled', 'true');
      }
    }

    return variant;
  }

  function setVariantPending(variantSelects) {
    const productInfo = variantSelects.closest(SELECTOR);
    const sectionId = variantSelects.dataset.section || productInfo?.dataset.section;
    if (sectionId) {
      productInfo
        ?.querySelectorAll(`#product-form-${sectionId} input[name="id"], #product-form-installment-${sectionId} input[name="id"]`)
        .forEach((input) => {
          input.value = '';
          input.disabled = true;
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
    }

    const submitButton = productInfo?.querySelector('[id^="ProductSubmitButton-"]');
    if (submitButton) {
      submitButton.setAttribute('disabled', 'disabled');
      submitButton.setAttribute('aria-disabled', 'true');
    }
  }

  function refreshSummaries(variantSelects) {
    variantSelects.querySelectorAll('[data-np-option-panel]').forEach((panel) => {
      const selected = panel.querySelector('input:checked') || panel.querySelector('select');
      const target = panel.querySelector('[data-np-option-summary-value]');
      if (target && selected) target.textContent = selected.value;
    });
  }

  function cleanLabel(label) {
    return (label || '').replace(/\s*\*$/, '').trim();
  }

  function selectedValueForStep(step) {
    const file = step.querySelector('input[type="file"]');
    if (file) return file.files && file.files.length ? file.files[0].name : '';

    if (step.classList.contains('np-product-custom-panel--prompt')) {
      const selects = stepSelects(step);
      const selected = selects.map((select) => select.value).filter(Boolean);
      return selected.length ? selected[selected.length - 1] : '';
    }

    const hiddenProperty = step.querySelector('input[type="hidden"][data-cheerzone-property]');
    if (hiddenProperty && hiddenProperty.value) return hiddenProperty.value.split('|').pop().trim();

    const checked = step.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value;

    const selects = Array.from(step.querySelectorAll('select'));
    const selected = selects.map((select) => select.value).filter(Boolean);
    if (selected.length) return selected[selected.length - 1];

    const text = step.querySelector('textarea, input[type="text"], input[type="email"]');
    if (text && text.value) return text.value;

    return '';
  }

  function stepSelects(step) {
    return Array.from(step.querySelectorAll('select')).filter((select) => !select.disabled);
  }

  function hasUsableSelectValue(select) {
    return Boolean(select && select.value && select.value.trim());
  }

  function isPromptStepComplete(step) {
    const selects = stepSelects(step);
    if (selects.length < 2) return false;
    return selects.every(hasUsableSelectValue);
  }

  function productFormElement(productInfo) {
    return productInfo.querySelector('form[action*="/cart/add"]');
  }

  function productFormComponent(productInfo) {
    return productInfo.querySelector('product-form');
  }

  function showProductFormError(productInfo, message) {
    const component = productFormComponent(productInfo);
    if (component && typeof component.handleErrorMessage === 'function') {
      component.handleErrorMessage(message);
      return;
    }

    const wrapper = productInfo.querySelector('.product-form__error-message-wrapper');
    const text = wrapper?.querySelector('.product-form__error-message');
    if (!wrapper || !text) return;
    text.textContent = message;
    wrapper.removeAttribute('hidden');
  }

  function clearProductFormError(productInfo) {
    const component = productFormComponent(productInfo);
    if (component && typeof component.handleErrorMessage === 'function') {
      component.handleErrorMessage();
      return;
    }

    const wrapper = productInfo.querySelector('.product-form__error-message-wrapper');
    if (wrapper) wrapper.setAttribute('hidden', '');
  }

  function customStepIsRequired(step) {
    return Boolean(
      step.querySelector('input[required], select[required], textarea[required]') ||
      Array.from(step.querySelectorAll('[data-cheerzone-property]')).some((control) => customizerControlIsRequired(control))
    );
  }

  function customizerControlIsRequired(control) {
    if (!control) return false;
    if (control.required) return true;
    const field = control.closest('.np-product-custom-panel, .cheerzone-custom-product__field');
    if (!field) return false;
    if (field.querySelector('input[required], select[required], textarea[required]')) return true;
    const label = field.querySelector('label, .np-product-option-summary > span');
    return Boolean(label && /\*/.test(label.textContent || ''));
  }

  function customControlComplete(control) {
    if (!control || control.disabled) return true;
    if (control.type === 'file') return Boolean(control.files && control.files.length);
    if (control.type === 'checkbox' || control.type === 'radio') return control.checked;
    return Boolean(control.value && control.value.trim());
  }

  function isRequiredCustomStepComplete(step) {
    if (!customStepIsRequired(step)) return true;
    if (step.classList.contains('np-product-custom-panel--prompt')) return isPromptStepComplete(step);

    const requiredControls = Array.from(step.querySelectorAll('input, select, textarea, [data-cheerzone-property]'))
      .filter((control, index, controls) => controls.indexOf(control) === index)
      .filter((control) => control.type !== 'hidden' || control.hasAttribute('data-cheerzone-property'))
      .filter(customizerControlIsRequired);
    return requiredControls.length > 0 && requiredControls.every(customControlComplete);
  }

  function requiredCustomSteps(productInfo) {
    return getSteps(productInfo).filter((step) =>
      step.classList.contains('np-product-custom-panel') && customStepIsRequired(step)
    );
  }

  function labelForStep(step) {
    return cleanLabel(step.querySelector('.np-product-option-summary > span')?.textContent || 'Auswahl');
  }

  function focusStep(step) {
    const focusTarget = step.querySelector('input:not([type="hidden"]):not(:disabled), select:not(:disabled), textarea:not(:disabled), summary');
    if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
  }

  function validateRequiredCustomizer(productInfo, event) {
    const missingStep = requiredCustomSteps(productInfo).find((step) => !isRequiredCustomStepComplete(step));
    if (!missingStep) {
      clearProductFormError(productInfo);
      return true;
    }

    event?.preventDefault();
    event?.stopPropagation();
    event?.stopImmediatePropagation?.();

    const steps = getSteps(productInfo);
    const missingIndex = Math.max(0, steps.indexOf(missingStep));
    setStepState(productInfo, missingIndex);
    missingStep.open = true;
    missingStep.classList.add('has-error');
    missingStep.scrollIntoView({ behavior: 'smooth', block: 'center' });
    focusStep(missingStep);
    showProductFormError(productInfo, `Bitte vervollständige zuerst: ${labelForStep(missingStep)}.`);
    return false;
  }

  function refreshRequiredCustomizerState(productInfo) {
    requiredCustomSteps(productInfo).forEach((step) => {
      step.classList.toggle('has-error', !isRequiredCustomStepComplete(step) && step.dataset.npTouched === 'true');
    });
  }

  function validateActiveProductCustomizer(event) {
    const productInfo = Array.from(document.querySelectorAll(SELECTOR)).find((info) => {
      const form = productFormElement(info);
      return form && requiredCustomSteps(info).length > 0;
    });
    return productInfo ? validateRequiredCustomizer(productInfo, event) : true;
  }

  function ensureStepNumber(summary) {
    if (summary.querySelector('.np-product-step-index')) return;
    const badge = document.createElement('em');
    badge.className = 'np-product-step-index';
    badge.textContent = '1';
    summary.prepend(badge);
  }

  function setTextIfChanged(node, value) {
    if (!node || node.textContent === value) return;
    node.textContent = value;
  }

  function stepTitleForCustomField(field) {
    const label = field.querySelector('label');
    return cleanLabel(label?.textContent) || 'Auswahl';
  }

  function stepKey(step) {
    if (step.dataset.npStepKey) return step.dataset.npStepKey;
    const title = cleanLabel(step.querySelector('.np-product-option-summary > span')?.textContent || '');
    const key = title || `step-${getSteps(step.closest(SELECTOR) || document).indexOf(step)}`;
    step.dataset.npStepKey = key;
    return key;
  }

  function completedStepSet(productInfo) {
    if (!productInfo.__npCompletedSteps) productInfo.__npCompletedSteps = new Set();
    return productInfo.__npCompletedSteps;
  }

  function markStepTouched(productInfo, step) {
    if (!step) return;
    step.dataset.npTouched = 'true';
    step.classList.add('is-touched');
    completedStepSet(productInfo).add(stepKey(step));
  }

  function enhanceCustomFields(productInfo) {
    productInfo.querySelectorAll('.cheerzone-custom-product__field').forEach((field) => {
      if (field.dataset.npStepConverted === 'true') return;
      field.dataset.npStepConverted = 'true';

      const title = stepTitleForCustomField(field);
      const panel = document.createElement('details');
      panel.className = 'np-product-option-panel np-product-custom-panel';
      if (field.classList.contains('cheerzone-custom-product__field--prompt-select')) {
        panel.classList.add('np-product-custom-panel--prompt');
      }
      panel.dataset.npStepItem = 'true';
      panel.dataset.npStepKey = title;

      const summary = document.createElement('summary');
      summary.className = 'np-product-option-summary';
      summary.innerHTML = '<span></span><strong data-np-option-summary-value>Auswaehlen</strong>';
      summary.querySelector('span').textContent = title;
      ensureStepNumber(summary);

      const body = document.createElement('div');
      body.className = 'np-product-step-body';
      while (field.firstChild) body.appendChild(field.firstChild);

      panel.appendChild(summary);
      panel.appendChild(body);
      field.replaceWith(panel);
    });
  }

  function prepareVariantSteps(productInfo) {
    productInfo.querySelectorAll('[data-np-option-panel]').forEach((panel) => {
      panel.dataset.npStepItem = 'true';
      stepKey(panel);
      if (completedStepSet(productInfo).has(stepKey(panel))) {
        panel.dataset.npTouched = 'true';
        panel.classList.add('is-touched');
      }
      const summary = panel.querySelector('.np-product-option-summary');
      if (summary) ensureStepNumber(summary);
    });
  }

  function getSteps(productInfo) {
    return Array.from(productInfo.querySelectorAll('[data-np-step-item]'));
  }

  function updateStepSummaries(productInfo) {
    getSteps(productInfo).forEach((step, index) => {
      const number = step.querySelector('.np-product-step-index');
      if (number) setTextIfChanged(number, String(index + 1).padStart(2, '0'));

      const valueTarget = step.querySelector('[data-np-option-summary-value]');
      const value = selectedValueForStep(step);
      const complete = isStepComplete(step, value);
      const displayValue = complete ? value : '';
      if (valueTarget) setTextIfChanged(valueTarget, displayValue || 'Auswaehlen');
      step.classList.toggle('is-complete', complete);
      if (step.classList.contains('np-product-custom-panel') && isRequiredCustomStepComplete(step)) {
        step.classList.remove('has-error');
      }
    });
  }

  function isStepComplete(step, value = selectedValueForStep(step)) {
    if (!value) return false;
    if (step.classList.contains('np-product-custom-panel--prompt')) return isPromptStepComplete(step);
    if (step.classList.contains('np-product-custom-panel')) return true;
    const productInfo = step.closest(SELECTOR);
    return step.dataset.npTouched === 'true' || (productInfo && completedStepSet(productInfo).has(stepKey(step)));
  }

  function firstIncompleteIndex(steps) {
    const index = steps.findIndex((step) => !step.classList.contains('is-complete'));
    return index;
  }

  function setStepState(productInfo, activeIndex, forceOpen = true) {
    const steps = getSteps(productInfo);
    steps.forEach((step, index) => {
      const locked = activeIndex >= 0 && index > activeIndex;
      step.classList.toggle('is-locked', locked);
      step.toggleAttribute('data-np-locked', locked);
      if (locked) step.open = false;
      if (!forceOpen) return;
      if (index === activeIndex) step.open = true;
      if (index < activeIndex && step.classList.contains('is-complete')) step.open = false;
      if (activeIndex === -1 && step.classList.contains('is-complete')) step.open = false;
    });
  }

  function advanceFromStep(productInfo, step) {
    const key = stepKey(step);
    window.setTimeout(() => {
      updateStepSummaries(productInfo);
      const steps = getSteps(productInfo);
      const currentStep = steps.find((item) => item === step || stepKey(item) === key);
      const index = steps.indexOf(currentStep);
      if (index === -1 || !currentStep.classList.contains('is-complete')) return;
      if (index === steps.length - 1) {
        currentStep.open = false;
        setStepState(productInfo, -1);
        return;
      }
      const next = Math.min(index + 1, steps.length - 1);
      setStepState(productInfo, next);
    }, 120);
  }

  function bindStepFlow(productInfo) {
    if (productInfo.dataset.npStepFlow === 'true') {
      updateStepSummaries(productInfo);
      return;
    }

    productInfo.dataset.npStepFlow = 'true';
    productInfo.addEventListener('toggle', (event) => {
      const step = event.target.closest?.('[data-np-step-item]');
      if (!step || !step.open) return;
      if (step.hasAttribute('data-np-locked')) {
        step.open = false;
        return;
      }
      getSteps(productInfo).forEach((other) => {
        if (other !== step) other.open = false;
      });
    }, true);

    productInfo.addEventListener('change', (event) => {
      const step = event.target.closest?.('[data-np-step-item]');
      if (!step) return;
      markStepTouched(productInfo, step);
      updateStepSummaries(productInfo);
      refreshRequiredCustomizerState(productInfo);
      advanceFromStep(productInfo, step);
    });

    productInfo.addEventListener('click', (event) => {
      const label = event.target.closest?.('label');
      const step = event.target.closest?.('[data-np-step-item]');
      if (!label || !step) return;
      const labelledControl = label.htmlFor ? document.getElementById(label.htmlFor) : label.querySelector('input, select');
      if (labelledControl?.disabled) {
        event.preventDefault();
        return;
      }
      markStepTouched(productInfo, step);
      window.setTimeout(() => {
        updateStepSummaries(productInfo);
        refreshRequiredCustomizerState(productInfo);
        advanceFromStep(productInfo, step);
      }, 80);
    });
  }

  function bindCustomizerSubmitValidation(productInfo) {
    if (productInfo.dataset.npCustomizerValidation === 'true') return;
    productInfo.dataset.npCustomizerValidation = 'true';

    productInfo.addEventListener('click', (event) => {
      const trigger = event.target.closest?.('button[type="submit"], [name="add"], [id^="ProductSubmitButton-"]');
      if (!trigger || !productInfo.contains(trigger)) return;
      validateRequiredCustomizer(productInfo, event);
    }, true);

    productInfo.addEventListener('submit', (event) => {
      const form = productFormElement(productInfo);
      if (!form || event.target !== form) return;
      validateRequiredCustomizer(productInfo, event);
    }, true);
  }

  function bindCartAddValidation() {
    if (window.__npCartAddValidation === true || !window.fetch) return;
    window.__npCartAddValidation = true;

    const originalFetch = window.fetch;
    window.fetch = function (input, init) {
      const url = typeof input === 'string' ? input : input?.url;
      if (url && /\/cart\/add(\.js)?/.test(url) && !validateActiveProductCustomizer()) {
        return Promise.reject(new Error('NOPREVIEW customizer required fields missing'));
      }
      return originalFetch.apply(this, arguments);
    };
  }

  function initializeStepFlow(productInfo) {
    prepareVariantSteps(productInfo);
    enhanceCustomFields(productInfo);
    updateStepSummaries(productInfo);
    bindStepFlow(productInfo);

    const steps = getSteps(productInfo);
    if (!steps.length) return;
    const alreadyStarted = productInfo.dataset.npStepStarted === 'true';
    const activeIndex = alreadyStarted ? firstIncompleteIndex(steps) : 0;
    productInfo.dataset.npStepStarted = 'true';
    setStepState(productInfo, activeIndex, !alreadyStarted);
  }

  function syncStepFlow(productInfo) {
    prepareVariantSteps(productInfo);
    enhanceCustomFields(productInfo);
    updateStepSummaries(productInfo);
    bindStepFlow(productInfo);

    const steps = getSteps(productInfo);
    if (!steps.length || productInfo.dataset.npStepStarted !== 'true') return;
    setStepState(productInfo, firstIncompleteIndex(steps), false);
  }

  function closeCurrentOpenNext(target) {
    const panel = target.closest('[data-np-option-panel]');
    if (!panel) return;

    window.setTimeout(() => {
      panel.open = false;
      const panels = Array.from(panel.parentElement.querySelectorAll('[data-np-option-panel]'));
      const nextPanel = panels[panels.indexOf(panel) + 1];
      if (nextPanel) nextPanel.open = true;
    }, 120);
  }

  function enhanceVariantPicker(root) {
    root.querySelectorAll('variant-selects').forEach((variantSelects) => {
      if (variantSelects.dataset.npEnhanced === 'true') return;
      variantSelects.dataset.npEnhanced = 'true';
      updateOptionAvailability(variantSelects);
      refreshSummaries(variantSelects);
      const initialVariant = syncVariant(variantSelects);
      if (initialVariant?.available) rememberAvailableSelection(variantSelects);

      variantSelects.addEventListener('pointerdown', (event) => {
        blockUnavailableChoice(event, variantSelects);
      }, true);

      variantSelects.addEventListener('click', (event) => {
        blockUnavailableChoice(event, variantSelects);
      }, true);

      variantSelects.addEventListener('change', (event) => {
        if (blockUnavailableChoice(event, variantSelects)) return;
        const changedIndex = optionIndexForControl(variantSelects, controlFromVariantEvent(variantSelects, event.target));
        clearInvalidFollowingSelections(variantSelects, changedIndex);
        updateOptionAvailability(variantSelects);
        refreshSummaries(variantSelects);
        const variant = syncVariant(variantSelects);
        if (variant?.available) {
          rememberAvailableSelection(variantSelects);
        } else {
          if (changedIndex >= 0 && changedIndex < getOptionGroups(variantSelects).length - 1) {
            setVariantPending(variantSelects);
            closeCurrentOpenNext(event.target);
            return;
          }
          restoreAvailableSelection(variantSelects);
          updateOptionAvailability(variantSelects);
          refreshSummaries(variantSelects);
          syncVariant(variantSelects);
          return;
        }
        closeCurrentOpenNext(event.target);
      });
    });
  }

  function getUploadExtension(file) {
    return (file?.name || '').split('.').pop().toLowerCase();
  }

  function readUploadHeader(file, byteCount = 32) {
    return file.slice(0, byteCount).arrayBuffer().then((buffer) => new Uint8Array(buffer));
  }

  function asciiFromBytes(bytes, start, length) {
    return Array.from(bytes.slice(start, start + length)).map((byte) => String.fromCharCode(byte)).join('');
  }

  async function validateImageUpload(file) {
    if (!file) return { valid: false, message: 'Bitte ein Bild auswaehlen.' };
    if (file.size > NP_UPLOAD_MAX_BYTES) return { valid: false, message: 'Das Bild ist zu gross. Bitte maximal 25 MB hochladen.' };

    const extension = getUploadExtension(file);
    const mime = (file.type || '').toLowerCase();
    if (!NP_UPLOAD_EXTENSIONS.has(extension)) return { valid: false, message: 'Bitte nur JPG, PNG, WebP, GIF, HEIC, HEIF oder AVIF hochladen.' };
    if (mime && !NP_UPLOAD_MIMES.has(mime)) return { valid: false, message: 'Dieser Dateityp ist nicht erlaubt.' };

    const bytes = await readUploadHeader(file);
    const isJpeg = bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff;
    const isPng = bytes[0] === 0x89 && asciiFromBytes(bytes, 1, 3) === 'PNG';
    const isGif = asciiFromBytes(bytes, 0, 3) === 'GIF';
    const isWebp = asciiFromBytes(bytes, 0, 4) === 'RIFF' && asciiFromBytes(bytes, 8, 4) === 'WEBP';
    const isIsoImage = asciiFromBytes(bytes, 4, 4) === 'ftyp' && ['heic', 'heix', 'hevc', 'hevx', 'heif', 'mif1', 'msf1', 'avif'].includes(asciiFromBytes(bytes, 8, 4).toLowerCase());

    if (!isJpeg && !isPng && !isGif && !isWebp && !isIsoImage) {
      return { valid: false, message: 'Die Datei sieht nicht wie ein echtes Bild aus.' };
    }

    return { valid: true, message: '' };
  }

  function setUploadError(input, message) {
    let error = input.parentElement?.querySelector('.np-upload-error');
    if (!message) {
      if (error) error.remove();
      return;
    }
    if (!error) {
      error = document.createElement('div');
      error.className = 'np-upload-error';
      error.setAttribute('role', 'alert');
      input.insertAdjacentElement('afterend', error);
    }
    error.textContent = message;
  }

  function enhanceUploadPreviews(root) {
    root.querySelectorAll('input[type="file"]').forEach((input) => {
      input.setAttribute('accept', NP_UPLOAD_ACCEPT);
      if (input.dataset.npPreview === 'true') return;
      input.dataset.npPreview = 'true';

      const preview = document.createElement('div');
      preview.className = 'np-upload-preview';
      preview.innerHTML = '<img alt="" loading="lazy"><span></span>';
      input.insertAdjacentElement('afterend', preview);

      input.addEventListener('change', async () => {
        const file = input.files && input.files[0];
        const image = preview.querySelector('img');
        const text = preview.querySelector('span');
        const token = file ? `${file.name}:${file.size}:${file.lastModified}` : '';
        input.dataset.npUploadToken = token;

        if (!file) {
          setUploadError(input, '');
          preview.classList.remove('is-visible');
          return;
        }

        const result = await validateImageUpload(file);
        if (input.dataset.npUploadToken !== token) return;

        if (!result.valid) {
          input.value = '';
          image.removeAttribute('src');
          image.hidden = true;
          text.textContent = '';
          preview.classList.remove('is-visible');
          setUploadError(input, result.message);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          return;
        }

        setUploadError(input, '');
        image.src = URL.createObjectURL(file);
        image.hidden = false;
        text.textContent = file.name;
        preview.classList.add('is-visible');
      });
    });
  }

  function observeAsyncFields(productInfo) {
    if (productInfo.dataset.npFieldObserver === 'true') return;
    productInfo.dataset.npFieldObserver = 'true';
    let scheduled = false;

    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      window.requestAnimationFrame(() => {
        scheduled = false;
        enhanceVariantPicker(productInfo);
        refreshAllVariantAvailability(productInfo);
        enhanceUploadPreviews(productInfo);
        syncStepFlow(productInfo);
      });
    });
    observer.observe(productInfo, { childList: true, subtree: true });
  }

  function enhanceProductPage(root = document) {
    bindCartAddValidation();
    root.querySelectorAll(SELECTOR).forEach((productInfo) => {
      bindAvailabilityGuards(productInfo);
      bindCustomizerSubmitValidation(productInfo);
      enhanceVariantPicker(productInfo);
      enhanceUploadPreviews(productInfo);
      initializeStepFlow(productInfo);
      observeAsyncFields(productInfo);
    });
  }

  document.addEventListener('DOMContentLoaded', () => enhanceProductPage());
  document.addEventListener('product-info:loaded', (event) => enhanceProductPage(event.target));
  document.addEventListener('shopify:section:load', (event) => enhanceProductPage(event.target));
})();
